/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");

// TODO: Be more smart with added and removed events

/**
 * Keeps track of the contact list, and the contacts' data
 * @type {Model}
 */
module.exports = Model({
	name: "usersmanagerlist",
	init: init,
	uninit: uninit,
	listeners: listeners,
	triggers: triggers,

	_managers: null, // The array of contact ids
	_people: null,

	recalculate: recalculate,
	refresh: refresh,
});

/**
 * Adds listeners for changes in the contact list, changes in the people store, and fetches the initial state
 * @return {Promise} Resolves to the initial state
 */
function init() {
	this._managers = [];
	this._people = {};

	this.refresh();

	this.push([]);
}

/**
 * Removes all listeners from the dispatcher and the people store
 * @return {Promise} Resolves after everything is done.
 */
function uninit() {
	this._managers = null;
	this._people = null;
}

function listeners() {
	return {
		"mqtt:$/manage/manager/added": handle_added,
		"mqtt:$/manage/manager/removed": handle_removed,
		"connectivity:online": refresh,
		"people:updated": Model.makeRecalculator("people"),
	};
}

function triggers() {
	return {
		"refresh": refresh,
	};
}

function recalculate() {
	var people = this._people;
	var managers = this._managers;

	this.push(managers.reduce(function (list, id) {
		var person = people[id];
		if (person) return list.concat(person);
		return list;
	}, []));
}

function handle_added(data) {
	var id = data.manager;
	if (this._managers.indexOf(id) !== -1) return;
	this._managers.push(id);
	this.recalculate();
	this.emit("people:trigger:add", {
		lean: true,
		who: [id]
	});
}

function handle_removed(data) {
	var id = data.manager;
	var oldSize = this._managers.length;

	this._managers = this._managers.filter(function (existing) {
		return existing !== id;
	});

	if (this._managers.length !== oldSize) this.recalculate();
}

/**
 * Refreshes the manager list and adds all managers to be watched by the people store
 * @return {Promise} Resolves when everything is refreshed and passed to people store
 */
function refresh() {
	return this.api.manage.managers.list() // Get the managers list
		.then(set_managers.bind(this)) // Set managers on the store
		.then(track_people.bind(this)); // Add all managers to people store
}

function track_people(who) {
	this.emit("people:trigger:add", {
		lean: true,
		who: who
	});
}

/**
 * Really kinda self-explanatory
 */
function set_managers(managers) {
	this._managers = managers;
	this.recalculate();
	return managers;
}
